import { ReduxState } from "@dashboard/types";

export const DefaultFeatureFlags: ReduxState["dashboardApp"]["featureFlags"] = {
  allowDishOrProductDeleteWithoutConfirmation: false,
  allowHidingDish: false,
  allowCsvImportExport: false,
  showIds: false,
  showIntegrationsPage: false,
  allowSupplierInfoEntry: false,
  showDemoRestaurantsOnly: false,
  showAdvancedProductFilters: false,
  showMenuSectionGroups: false,
  enableGuestMenuV2: false,
};
